import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { ViewWillEnter } from '@ionic/angular';

import { AreaSelectionModalPage, AreaSelectionModalPageIdentifier } from '../../modals/area-selection-modal/area-selection-modal.page';

import { Address } from '../../core/models/address.model';
import { COUNTRY, Country } from '../../core/models/country.model';

import { ModalService } from '../../core/services/modal.service';
import { NavigationService } from '../../core/services/navigation.service';
import { SettingsService } from '../../core/services/settings.service';
import { VendorsService } from '../../core/services/vendors.service';

@Component({
  selector: 'app-browser-home',
  templateUrl: './browser-home.page.html',
  styleUrls: ['./browser-home.page.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BrowserHomePage implements OnInit, ViewWillEnter {
  public selectedAddress: Address;
  public availableCountries: Array<Country>;
  public currentCountryPartnersLogosUrl: string;

  private partnersLogosUrl = {
    [COUNTRY.kuwait.code]: 'https://cdn.bilbayt.com/assets/homepage-logos-kuwait-636796881405946706.png',
    [COUNTRY.uae.code]: 'https://cdn.bilbayt.com/assets/homepage-logos-uae-636796882672061094.png',
  };

  constructor(
    private modalService: ModalService,
    private vendorsService: VendorsService,
    private navigationService: NavigationService,
    private settingsService: SettingsService,
  ) {}

  ngOnInit(): void {
    this.selectedAddress = this.vendorsService.getAddressSearchFilters();
    this.availableCountries = this.settingsService.getAvailableCountries();
    this.currentCountryPartnersLogosUrl = this.partnersLogosUrl[this.settingsService.getCountry().code];
  }

  ionViewWillEnter(): void {
    this.selectedAddress = this.vendorsService.getAddressSearchFilters();
  }

  public onContinue(): void {
    if (!this.selectedAddress) {
      this.onOpenAreaSelectionModal();
      return;
    }

    this.redirectToSearchResults();
  }

  public onOpenAreaSelectionModal(): void {
    void this.modalService
      .showCard<Address>({
        component: AreaSelectionModalPage,
        id: AreaSelectionModalPageIdentifier,
        presentingElement: undefined,
        componentProps: {
          showCloseButton: true,
          selectedAddress: this.selectedAddress,
        },
      })
      .then((selectedAddress) => {
        if (!selectedAddress) {
          return;
        }

        this.selectedAddress = selectedAddress;
        this.vendorsService.setAddressSearchFilters(selectedAddress);
        this.redirectToSearchResults();
      });
  }

  public onSkipAreaSelection(): void {
    this.redirectToSearchResults();
  }

  public onCountryChange(country: Country): void {
    const defaultLanguage = this.settingsService.getLanguage();
    this.settingsService.changeCountryAndLanguage(country, defaultLanguage);
    void this.navigationService.navigateBackToTab(`/${country.code}/${defaultLanguage.value}`);
  }

  private redirectToSearchResults(): void {
    const currentCountry = this.settingsService.getCountry();
    const currentLanguage = this.settingsService.getLanguage();
    void this.navigationService.navigateBackToTab(`/${currentCountry.code}/${currentLanguage.value}/vendors`);
  }
}
